module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "typebar-wrap"
  }, [_c('ul', {
    ref: "typebar",
    staticClass: "typebar"
  }, _vm._l((_vm.typeList), function(item, index) {
    return _c('li', {
      class: {
        active: _vm.selectTypeIndex === index
      },
      style: ({
        color: _vm.selectTypeIndex === index ? _vm.activeColor : _vm.color,
        'border-color': _vm.bdColor
      }),
      on: {
        "click": function($event) {
          _vm.selectItem(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-021ee425!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/typebar.vue
// module id = 328
// module chunks = 1